/* Rosebound — book club badges (Nov 2026).
   Reads /collections/book-club-picks?section_id=rb-book-club-map (sections/rb-book-club-map.liquid) and:
   - puts a "Book club · Nov" badge on the cover of this month's picks, wherever book cards show
   - puts a quiet "Book club pick · Oct 2026" line under the price of past picks
   - adds a book club box under the price on a pick's own page (meeting date + sign-up for current picks)
   The data is kept for 20 minutes per visit so it's one small request, not one per page. */
(function () {
  if (window.RBBC) return;
  window.RBBC = true;

  var KEY = 'rbbc-v1', TTL = 20 * 60 * 1000;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return c.d;
    } catch (e) {}
    return null;
  }
  function writeCache(d) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }
  function load() {
    var c = readCache();
    if (c) return Promise.resolve(c);
    return fetch(root + 'collections/book-club-picks?section_id=rb-book-club-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-rbbc>([\s\S]*?)<\/script>/);
        if (!m) return null;
        var d = JSON.parse(m[1]);
        writeCache(d);
        return d;
      })
      .catch(function () { return null; });
  }

  function monthLabel(ym, full) {
    var p = (ym || '').split('-');
    var i = parseInt(p[1], 10) - 1;
    if (!(i >= 0 && i < 12)) return '';
    return (full ? FULL[i] : MONTHS[i]) + ' ' + p[0];
  }
  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var CSS = [
    '.rbbc-badge{position:absolute;top:.8rem;left:.8rem;z-index:2;background:#854a4c;color:#fff;font-size:1.1rem;line-height:1.3;letter-spacing:.1rem;text-transform:uppercase;padding:.4rem .8rem;border-radius:.3rem;pointer-events:none;max-width:calc(100% - 1.6rem)}',
    '.rbbc-past{margin:.4rem 0 0;font-size:1.3rem;line-height:1.4;letter-spacing:.02rem;color:#aa6d6b}',
    '.rbbc-box{margin:1.6rem 0 2rem;padding:1.6rem 1.8rem;border:1px solid rgba(170,109,107,.35);border-radius:.6rem;background:#fff8f7}',
    '.rbbc-box__eyebrow{margin:0;font-size:1.15rem;letter-spacing:.14rem;text-transform:uppercase;color:#aa6d6b}',
    '.rbbc-box__title{margin:.4rem 0 0;font-size:1.8rem;line-height:1.3;color:#854a4c}',
    '.rbbc-box__when{margin:.6rem 0 0;font-size:1.45rem;line-height:1.5}',
    '.rbbc-box__perk{margin:.4rem 0 0;font-size:1.3rem;line-height:1.5;color:rgba(var(--color-foreground),.7)}',
    '.rbbc-box__btn{margin-top:1.2rem;min-height:4.2rem;padding:0 1.8rem;background:#854a4c;color:#fff;font-family:var(--font-heading-family);letter-spacing:.2rem;text-transform:uppercase;font-size:1.3rem}',
    '.rbbc-box__btn::after{box-shadow:none}.rbbc-box__btn:hover{background:#aa6d6b}',
    '.rbbc-box__full{display:block;margin-top:1rem;font-size:1.4rem;color:#854a4c}',
    '.rbbc-pastline{margin:1.2rem 0 1.6rem;font-size:1.3rem;letter-spacing:.1rem;text-transform:uppercase;color:#aa6d6b}',
    '.rbbc-pastline a{color:#854a4c}'
  ].join('');

  function index(d) {
    var cur = {}, past = d.past || {};
    (d.current || []).forEach(function (c) {
      (c.books || []).forEach(function (h) { if (h) cur[h.toLowerCase()] = c; });
    });
    return { cur: cur, past: past };
  }

  function badgeCards(ix) {
    /* .card-wrapper = theme book cards (homepage rows, search); .rbf-card = the filter grid on collection pages */
    var cards = document.querySelectorAll('.card-wrapper:not([data-rbbc]), .rbf-card:not([data-rbbc])');
    [].forEach.call(cards, function (w) {
      w.setAttribute('data-rbbc', '1');
      var rbf = w.classList.contains('rbf-card');
      var a = w.querySelector('a[href*="/products/"]');
      var h = handleOf(a && a.getAttribute('href'));
      if (!h) return;
      var c = ix.cur[h];
      if (c) {
        var inner = rbf ? w.querySelector('.rbf-img') : (w.querySelector('.card__inner') || w.querySelector('.card__media'));
        if (inner) inner.appendChild(el('span', 'rbbc-badge', 'Book club · ' + (c.monthName || '').slice(0, 3)));
        return;
      }
      var m = ix.past[h];
      if (m) {
        var spot;
        if (rbf) spot = w;
        else {
          var info = w.querySelectorAll('.card-information');
          spot = info.length ? info[info.length - 1] : w.querySelector('.card__information');
        }
        if (spot) spot.appendChild(el('p', 'rbbc-past', 'Book club pick · ' + monthLabel(m)));
      }
    });
  }

  function productBox(ix) {
    var h = handleOf(location.pathname);
    if (!h || !/\/products\//.test(location.pathname)) return;
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.rbbc-box, .rbbc-pastline')) return;
    var price = info.querySelector('[id^="price-"]');
    var c = ix.cur[h], box;
    if (c) {
      box = el('div', 'rbbc-box');
      box.appendChild(el('p', 'rbbc-box__eyebrow', 'Rosebound Readers Club'));
      box.appendChild(el('p', 'rbbc-box__title', c.monthName + ' ' + c.chapter + ' pick'));
      if (c.when) box.appendChild(el('p', 'rbbc-box__when', 'We meet ' + c.when + ' at the shop.'));
      box.appendChild(el('p', 'rbbc-box__perk', 'Book club members get 10% off this book in store.'));
      if (c.open) {
        var b = el('a', 'button rbbc-box__btn', 'Save your seat – ' + c.price);
        b.href = c.url;
        box.appendChild(b);
      } else {
        box.appendChild(el('span', 'rbbc-box__full', 'This month’s meeting is full.'));
      }
    } else if (ix.past[h]) {
      box = el('p', 'rbbc-pastline');
      box.appendChild(document.createTextNode('Rosebound book club pick · ' + monthLabel(ix.past[h], true) + ' · '));
      var l = el('a', 'link', 'See all our picks');
      l.href = root + 'collections/book-club-picks';
      box.appendChild(l);
    }
    if (!box) return;
    var tax = price && price.parentNode.querySelector('.product__tax');
    var after = tax || price;
    if (after) after.insertAdjacentElement('afterend', box);
    else info.insertBefore(box, info.firstChild);
  }

  function run() {
    load().then(function (d) {
      if (!d || (!(d.current || []).length && !Object.keys(d.past || {}).length)) return;
      var s = el('style', null, CSS);
      document.head.appendChild(s);
      var ix = index(d);
      badgeCards(ix);
      productBox(ix);
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; badgeCards(ix); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();